<script>
import { defineComponent } from "vue";
import ic_service from "@icon/ic_service.svg";
import ic_openL from "@icon/ic_openL.svg";
import icKa from "@icon/ic-ka.svg";
import { updateServiceRequest } from "@/component/cdevs/allFunctions";
import PopupApprouve from "./PopupApprouve.vue";

export default defineComponent({
  name: "RequestLists",
  components: { PopupApprouve },
  props: {
    oneRequest: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["refresh"],
  data() {
    return {
      icons: { ic_service, icKa, ic_openL },
      showPopup: false, // état pour afficher/masquer le popup
    };
  },
  methods: {
    async updateState() {
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        isActive: false,
        id: this.oneRequest.request.id,
        state: "TREATED",
      };

      await updateServiceRequest(data)
        .then((response) => {
          console.log(response);
          this.charge = false;
          this.$toast.success("Service mis à jour avec succès");
          this.$emit("refresh");
          this.showPopup = false; // on le ferme
        })
        .catch((error) => {
          console.log(error);
          this.charge = false;
          this.$toast.error("Une erreur est survenue");
        });
    },
    truncateText(text, maxLength, suffix = "...") {
      if (!text || text.length <= maxLength) {
        return text;
      }
      return text.slice(0, maxLength) + suffix;
    },
    openPopup() {
      this.showPopup = true; // on affiche le popup
    },
    closePopup() {
      this.showPopup = false; // on le ferme
    },
  },
});
</script>

<template>
  <div class="RequestLists">
    <div
      class="border-b BorderColor w-full flex items-center px-5 h-20 cursor-pointer gap-2"
      @click="openPopup"
    >
      <div class="w-1/2 flex justify-start items-center gap-5 truncate">
        <div @click.stop="$emit('selected', oneRequest)">
          <icon
            :data="icons.ic_openL"
            height="20"
            width="20"
            class="w-4 h-4 cursor-pointer"
            original
          />
        </div>
        <div class="flex items-center gap-2">
          <icon
            :data="icons.icKa"
            height="32"
            width="32"
            class="w-8 h-8"
            original
          />
          {{ oneRequest.company.fullName }}
        </div>
      </div>
      <div class="w-1/2 flex justify-start items-center gap-5">
        <div class="flex items-center gap-3">
          <icon
            :data="icons.ic_service"
            height="20"
            width="20"
            class="w-5 h-5"
            original
          />
          {{ truncateText(oneRequest.request.serviceChoice.title, 50) }}
        </div>
      </div>
      <div class="w-1/3 flex justify-start">
        {{
          new Date(oneRequest.request.serviceChoice.created_at).toLocaleDateString()
        }}
      </div>
      <div class="w-1/3 flex justify-start">
        {{ new Date(oneRequest.request.created_at).toLocaleDateString() }}
      </div>
      <div class="w-1/4 Email responsive-large flex justify-start">
        <div
          v-if="oneRequest.request.state === 'WAITING'"
          class="wait px-7 py-2 rounded-100 cursor-pointer"
          @click.stop="updateState"
        >
          En attente
        </div>
        <div
          v-if="oneRequest.request.state === 'TREATED'"
          class="finish px-7 py-2 rounded-100 cursor-pointer"
        >
          Traitée
        </div>
      </div>
    </div>

    <!-- Popup -->
    <PopupApprouve
      v-if="showPopup"
      :oneRequest="oneRequest"  
      @close="closePopup"
      @updateState="updateState"
    />
  </div>
</template>


<style scoped lang="scss">
@media (max-width: 1600px) {
  .WidthContain {
    font-size: 14px;
    // justify-content: space-between; /* Distribution avec espace entre les éléments */
  }
}

.wait {
  color: #fb9c37;
}

.finish {
  color: #31b049;
}

.BGColorReject {
  color: #f04c36;
}
</style>
